<template>
  <div>
    <el-form
      :model="EditForm"
      label-width="120px"
      :rules="EditFormRule"
      ref="EditFormRule"
      auto-complete="off"
    >
      <el-card shadow="hover" style="margin-top: 10px; width: 100%">
        <div slot="header" class="clearfix">
          <span>运输信息</span>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <el-link type="warning" v-if="this.viewtype > 0"
                >请正确核对物流信息</el-link
              >[{{ EditForm.outboundNo }}]
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item label="参考单号：" prop="OrgOutboundNo">
              <el-input
                v-model="EditForm.orgOutboundNo"
                auto-complete="off"
                placeholder="请输入柜号"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="仓库：" prop="warehouseName">
              <el-input
                v-model="EditForm.warehouseName"
                auto-complete="off"
                placeholder="请输入封条号"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="运输方式：" prop="transportType">
              <el-input
                v-model="EditForm.transportType"
                auto-complete="off"
                placeholder="请输入SO"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="客户：" prop="customName">
              <el-input
                v-model="EditForm.customName"
                auto-complete="off"
                placeholder="请输入车牌"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="创建时间：" prop="createTime">
              <el-input
                v-model="EditForm.createTime"
                auto-complete="off"
                placeholder="请输入司机"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="预计出库日期：" prop="deliveryDate">
              <el-input
                v-model="EditForm.deliveryDate"
                auto-complete="off"
                placeholder="请输入电话"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
           <el-col :span="8">
            <el-form-item label="实际出库日期：" prop="actDeliveryDate">
              <el-input
                v-model="EditForm.actDeliveryDate"
                auto-complete="off"
                placeholder="请输入电话"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
           <el-col :span="8">
            <el-form-item label="总箱数：" prop="boxCount">
              <el-input
                v-model="EditForm.boxCount"
                auto-complete="off"
                placeholder="请输入电话"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
           <el-col :span="8">
            <el-form-item label="已发箱数：" prop="sendBoxCount">
              <el-input
                v-model="EditForm.sendBoxCount"
                auto-complete="off"
                placeholder="请输入电话"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <el-card shadow="hover" style="margin-top: 10px; width: 100%">
        <div slot="header" class="clearfix">
          <span>箱子明细</span>
        </div>

        <el-table
          :data="tableData"
          highlight-current-row
          border
          style="width: 100%;heiht"
        >
          <el-table-column prop="orgCustomerNo" label="参考单号"> </el-table-column>

          <el-table-column prop="deliveryOrdeNo" label="收货单号">
          </el-table-column>
          <el-table-column prop="customerBox" label="箱号">
          </el-table-column>
          <el-table-column prop="boxMark" label="唛头">
          </el-table-column>

          <el-table-column prop="boxStatusText" label="状态">
          </el-table-column>
          <el-table-column prop="brand" label="尺寸/(长*宽*高)">
            <template slot-scope="scope">
              {{ scope.row.actualBoxLength }}*{{ scope.row.actualBoxWidth }}*{{ scope.row.actualBoxHeight }}
            </template>
          </el-table-column>
           <el-table-column prop="actualBoxWeight" label="毛重">
          </el-table-column>
        </el-table>
      </el-card>
      <el-card
        shadow="hover"
        style="margin-top: 10px; width: 100%"
        v-if="this.viewtype > 0"
      >
        <div style="text-align: center">
          <el-button type="success" @click="passLoadingReview">通过</el-button>
          <el-button type="danger" @click="refuseLoadingReview">
            拒绝</el-button
          >
        </div>
      </el-card>
    </el-form>

    <el-dialog
      title="复核拒绝"
      :visible.sync="refusedialogVisible"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="拒绝原因:">
          <el-input
            type="textarea"
            maxlength="100"
            placeholder="字数限制100"
            v-model="RefuseReason"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="refuseSubmit">保 存</el-button>
          <el-button @click="refusedialogVisible = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetPutOnCarLoadingReviewDataList,
  GetPutOnCarLoadingReviewImageList,
  PutOnCarReviewSubmit,
  GetPutOnCarLoadingReviewBoxInfo,
} from "@/api/outbound/loadingReview.js";

import {
  getOutboundDetail,
} from "@/api/outbound/outboundOrder.js";

import { GetContainerTypeList } from "@/api/common/common.js";
import axios from "axios";
export default {
  data() {
    return {
      tableData: [],
      IsShowDeliver: true,
      LoadCarInfo: {},
      srcList: [],
      ContainerTypeList: [],
      refusedialogVisible: false,
      RefuseReason: "",
      viewtype: 0,
      form: {},
      EditForm: {},
      EditFormRule: {
        carNumber: [{ required: true, message: "请输入", trigger: "blur" }],
        driver: [{ required: true, message: "请输入司机", trigger: "blur" }],
        cabinetType: [
          { required: true, message: "请选择柜型", trigger: "blur" },
        ],
        driverPhone: [
          { required: true, message: "请输入电话", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    //this.init();
  },
  methods: {
    refusehandleClose() {},
    refuseSubmit() {
      const that = this;
      const loading = this.$loading({
        lock: true,
        text: "操作中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      const para = {
        loadCarInfoID: this.$route.query.loadCarInfoID,

        RefuseReason: this.RefuseReason,
        ReviewType: 2,
      };

      PutOnCarReviewSubmit(para).then((res) => {
        loading.close();
        if (res.success == true) {
          this.refusedialogVisible = false;
          this.$alert("保存成功", {
            confirmButtonText: "确定",
            callback: (action) => {
              window.parent.postMessage("close", "*");
            },
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
          return;
        }
      });
    },
    passLoadingReview() {
      // if (this.tableData[0] == null || this.tableData[0].length <= 0) {
      //   this.$message({
      //     message: "没有装车单货柜信息",
      //     type: "error",
      //   });
      //   return false;
      // }

      if (this.EditForm.cabinetType!="无" && this.EditForm.cabinetType!="散装") {
        if (
          this.EditForm.containerNumber == "" ||
          this.EditForm.sealNumber == "" ||
          this.EditForm.soNumber == ""
        ) {
          this.$message({
            message: "填柜型时：柜号,封条号,SO不能为空!",
            type: "error",
          });
          return false;
        }
      }

      console.log(this.EditFormRule);
      this.$refs.EditFormRule.validate((valid) => {
        if (valid) {
          debugger;
          if (this.EditForm.carNumber != "") {
            let regcarNumber =
              /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9挂学警港澳]{1}$/;
            if (!regcarNumber.test(this.EditForm.carNumber)) {
              this.$message({
                message: "请输入正确的车牌号，正确格式为（京A88888）",
                type: "error",
              });
              return false;
            }
          }

          if (this.EditForm.driverPhone != "") {
            let regdriverPhone =
              /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(18[0-9]{1})|(17[0-9]{1})|(14[0-9]{1})|(19[0-9]{1}))+\d{8})$/;
            if (!regdriverPhone.test(this.EditForm.driverPhone)) {
              this.$message({
                message: "请输入正确的电话号码",
                type: "error",
              });
              return false;
            }
          }
          if (this.EditForm.referenceNo != "") {
            let regreferenceNo = /^[0-9a-zA-Z\-]*$/;
            if (!regreferenceNo.test(this.EditForm.referenceNo)) {
              this.$message({
                message:
                  "请输入正确的装车参考单号，正确格式为（ZC-2-210830-0001、ZC00001）",
                type: "error",
              });
              return false;
            }
          }

          let reg = /^[0-9a-zA-Z]*$/;
          if (this.EditForm.containerNumber != "") {
            if (!reg.test(this.EditForm.containerNumber)) {
              this.$message({
                message: "请输入正确的柜号，正确格式为字母、字数",
                type: "error",
              });
              return false;
            }
          }

          if (this.EditForm.soNumber != "") {
            if (!reg.test(this.EditForm.soNumber)) {
              this.$message({
                message: "请输入正确的SO号，正确格式为字母、字数",
                type: "error",
              });
              return false;
            }
          }

          var remindBoxNum = "";

          const loading2 = this.$loading({
            lock: true,
            text: "请稍等...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.5)",
          });
          GetPutOnCarLoadingReviewBoxInfo({
            loadCarInfoID: this.$route.query.loadCarInfoID,
          }).then((res) => {
            loading2.close();
            if (res.response) {
              remindBoxNum = "发货箱子数:" + res.response.shippedBoxNum + " ";
              remindBoxNum +=
                "不发箱子数:" + res.response.noShippedBoxNum + " ";
              remindBoxNum +=
                "未选择箱子数(未选择默认为不发货):" +
                res.response.noSelectBoxNum;
            }

            this.$confirm(remindBoxNum, "确认复核？", {})
              .then(() => {
                const loading = this.$loading({
                  lock: true,
                  text: "提交中，请稍等",
                  spinner: "el-icon-loading",
                  background: "rgba(0, 0, 0, 0.5)",
                });

                const para = {
                  loadCarInfoID: this.$route.query.loadCarInfoID,
                  carNumber: this.EditForm.carNumber,
                  driverPhone: this.EditForm.driverPhone,
                  referenceNo: this.EditForm.referenceNo,
                  containerNumber: this.EditForm.containerNumber,
                  sealNumber: this.EditForm.sealNumber,
                  soNumber: this.EditForm.soNumber,
                  driver: this.EditForm.driver,
                  ReviewType: 1,
                  cabinetType: this.EditForm.cabinetType,
                };

                PutOnCarReviewSubmit(para).then((res) => {
                  loading.close();

                  if (res.success == true) {
                    this.$alert(res.msg, {
                      confirmButtonText: "确定",
                      callback: (action) => {
                        window.parent.postMessage("close", "*");
                      },
                    });
                  } else {
                    this.$message({
                      message: res.msg,
                      type: "error",
                    });
                    return;
                  }
                });
              })
              .catch((err) => {
                console.log(err);
              });
          });
        }
      });
    },
    refuseLoadingReview() {
      const para = {
        loadCarInfoID: this.$route.query.loadCarInfoID,
      };
      this.refusedialogVisible = true;
    },

    init() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      const para = {
        outboundID: this.$route.query.outboundID,
      };


      this.viewtype = this.$route.query.viewtype;

      getOutboundDetail(para).then((res) => {
        console.info(res);
        loading.close();
        if (res.data.response) {
          if (res.data.response.boxList) {
            this.tableData = res.data.response.boxList;
          }
          this.LoadCarInfo = res.data.response;
          this.EditForm = res.data.response;
        }
      });
    },
  },
  mounted() {
    this.init();
  },
  watch: {},
};
</script>

<style scoped lang="less">
.left-item {
  float: left;
  width: 20%;
  // min-width: 285px;
}
.left-item-card {
  max-height: 500px;
  overflow: hidden;
  overflow-y: scroll;
}

el-input {
  width: 100px;
}

.left-item-card {
  &::-webkit-scrollbar {
    height: 6px;
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: #fff;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(207, 210, 217);
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: rgb(184, 182, 182);
  }
}
.image-box {
  float: left;
  width: 20%;
  text-align: center;
  margin: 20px 100px;
  height: 200px;
}
.sign-photo-btn {
  width: 100px;
  border: 1px dashed #ccc;
  margin: 0 auto;
  height: 100px;
  cursor: pointer;
}
.sign-photo-btn:hover {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 15%);
}
.sign-photo-item:hover {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 15%);
}
.photo-s {
  color: #bfbfbf;
  padding: 23px 0;
  margin: 0;
  i {
    font-size: 55px;
  }
}
.sign-photo-item {
  height: 100px;
  width: 100px;
  margin: 0 auto;
  position: relative;
  img {
    height: 100px;
    width: 100px;
  }
}
.del-box {
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 25px;
  i {
    cursor: pointer;
    color: rgb(248, 248, 248);
    margin-top: 35px;
  }
}
.loading-box {
  background-color: rgba(255, 255, 255, 0.5);
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 25px;
  i {
    color: rgb(224, 222, 222);
    margin-top: 35px;
  }
}
.hidden {
  display: none;
}
</style>

<style>
.all-status {
  /* text-align: end; */
  height: 43px;
  padding-top: 15px;
  float: left;
}

.all-right {
  text-align: end;
  height: 43px;
  padding-top: 15px;
  float: left;
  margin-right: 10px;
  margin-left: 200px;
}

.all-clear {
  clear: both;
}

.hide .el-upload--picture-card {
  display: none;
}
</style>
